<script setup lang="ts">
</script>

<template>
  <div class="pb-safe">
    <slot />
  </div>
</template>
